import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sass-one-counter',
  templateUrl: './sass-one-counter.component.html',
  styleUrls: ['./sass-one-counter.component.scss']
})
export class SassOneCounterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
